export default __webpack_public_path__ + "0887cea26dbb47cf679f4ce6f65f7b12.png";